module.exports = __webpack_public_path__ + "static/turquia-013.thumb-472ff2eb40f3f55e695de6356cefaf86.jpg";